/*
	OneSP 1.0.0 Usage (Webpack)
	Yang @onerockwell
	
	Shipping Protection (BIG Projects)
*/

// Import all dependencies here
import Backbone from 'backbone';

import '../../styles/modules/oneSP.scss';

// Define a new console, to enable debugging logs please set 1r_debugging cookie with value of true using `ORW.utilities.setCookie('1r_debugging',true)`
const console = (function(oldCons){
	ORW.debugging = ORW.utilities.getCookie('1r_debugging');
    return {
        log: function(text){
            ORW.debugging == `true` && oldCons.log(text);
        },
        info: function (text) {
            ORW.debugging == `true` && oldCons.info(text);
        },
        warn: function (text) {
            ORW.debugging == `true` && oldCons.warn(text);
        },
        debug: oldCons.debug,
        error: function (text) {
            oldCons.error(text);
            if (window?.newrelic) {
                var err = new Error(text);
                window.newrelic.noticeError(err);
            }
        }
    };
}(window.console));

// Define the Backbone View here (Optional)
const OneSPView = Backbone.View.extend({
	
	initialize: async function (settings) {
		const self = this

		console.log(`SP Config: Init SP ...`);

		if (!ORW.SP || ORW.SP.enable != `true`) {
			console.log(`SP Config: SP is disabled`);
			return false
		}

		if (!ORW.SP.product.variantId) {
			console.log(`SP Config: SP is enabled but the SP product is not available to the current market`);
			return false
		}

        // Global variables
        self.UIInjected = false
        console.log(`SP Config: SP is enabled`);
        console.log(ORW.SP)

		if (ORW.SP.autoOptIn == `true`) {
			console.log(`SP Config: Auto opted in`)
		}

		// Start the cart watcher
		const myCartWatcher = new CartWatcher
		myCartWatcher.init()
		window.addEventListener("cart_changed", async (e) => {
			console.log(`Cart updated`);
			console.log(e.detail)
			const cartDetails = e.detail
			if (cartDetails.currentCart) await self.validate(cartDetails.currentCart)
		})

        // Start the action watcher
		self.action = {}
		self.actionProxy = new Proxy(self.action, {
			set: function (target, key, value) {
				console.log(`SP Action: ${key} - ${value}`)
				target[key] = value	// key will be `loading`, value will be boolean `true` or `false`
				if (value) {
					document.body.classList.add(`sp-in-action`)
				} else {
					document.body.classList.remove(`sp-in-action`)
				}
				return true
			}
		})
		self.actionProxy.loading = false
	},

	events: {
		'click .sp-button': async function (e) {
			const self = this
			// alert(`SP Button toggle!`)
            const spButton = e.currentTarget

            if (localStorage.getItem('spOptIn')) {
                // User want to remove SP
                await self.removeSP()
				self.updateStatus(false, true)
            } else {
                // User want to add SP
                await self.addSP()
				self.updateStatus(true, true)
            }
		},
	},

	onCartUpdate: async function (e) {

	},

	validate: async function (items) {
		const self = this
		console.log(`SP Validation: Cart validating ... `)

        if (items.length) {
            // Check SP interface
            !self.UIInjected && self.render()

            // Check SP item (by vendor or by properties)
            const sp_item = items.find((item) => {
                return item.vendor == "NuEthic" // return item.properties && item.properties.shipping_protection
            })
            // Check SP amount (cart amount that eligible for SP)
            const sp_amount = items.reduce((acc, item) => {
				if (item.requires_shipping && item.vendor != "NuEthic") {
					return acc + item.final_line_price
				}
				return acc
			}, 0)

            // Cart total validation
            if (sp_amount > 200000 || sp_amount == 0) {
                console.log(`SP Validation: Cart total is not in SP valid range, disable SP interface and reset SP status`)
                if (sp_item) await self.removeSP(sp_item.variant_id)
                self.UIInjected && self.render(true)
                self.updateStatus(false)
                return
            }

			console.log(`====================== check SP item ======================`);
			console.log(sp_item);			

            // Status validation
            if (sp_item) {
                if (!localStorage.getItem('spOptIn')) {
                    console.log(`SP Validation: SP item is in cart but user is not opted in, remove the SP`)
                    await self.removeSP(sp_item.variant_id)
                    self.updateStatus(false)
                } else {
                    self.updateStatus(true)
                }
            } else {
				/*
					SP item is not in cart, but cart is eligible for SP
					- Auto Opt-In enabled
						- If user is has not opted in (`spOptIn_user` is neither `opt_in` nor `opt_out`), add the SP
						- If user is currently opted in (`spOptIn_user` is `opt_in`), add the SP
						- If user is currently opted out (`spOptIn_user` is `opt_out`), do nothing
					- Auto Opt-In disabled
						- Use the flag `spOptIn` to determine if user is opted in
				*/

				console.log(`====================== No SP item, but cart is eligible, checking ======================`);

				if (ORW.SP.autoOptIn == `true`) {
					if (localStorage.getItem('spOptIn_user') == null) {
						console.log(`SP Validation: SP item is not in cart but auto-opt is enabled, add the SP`)
						console.log(localStorage.getItem('spOptIn_user'))
						await self.addSP()
						self.updateStatus(true, true)
					} else if (localStorage.getItem('spOptIn_user') == `opt_in`) {
						console.log(`SP Validation: SP item is not in cart but user opted in, add the SP`)
						await self.addSP()
						self.updateStatus(true)
					} else {
						console.log(`SP Validation: SP item is not in cart but user opted out, don't add the SP automatically`)
						self.updateStatus(false)
					}
				} else {
					if (localStorage.getItem('spOptIn')) {
						console.log(`SP Validation: SP item is not in cart but user is opted in, add the SP`)
						await self.addSP()
						self.updateStatus(true)
					} else {
						self.updateStatus(false)
					}
				}
            }

            self.updateSPPrice(sp_amount)
        } else {
            console.log(`SP Validation: Cart is empty, disable SP interface and reset SP status`)
            self.UIInjected && self.render(true)
            self.updateStatus(false)
        }
	},

    render: function(removal = false) {
        const self = this
        const spModule = document.querySelector(`.sp-module`)
        const spModuleContainer = document.querySelectorAll(`.sp-module-container`)

        if (removal) {
            spModuleContainer.forEach((el) => {
                el.remove()
            })
            self.UIInjected = false
            console.log(`SP UI: SP interface removed`)
        } else {
            // Inject the SP module
            spModuleContainer.length == 0 && document.querySelectorAll(`.cart-summary-wrapper .summary-title`).forEach((el) => {
                el.insertAdjacentHTML(
                    'afterend', 
                    `<div class="sp-module-container">${spModule.innerHTML}</div>`
                )
            })
            self.UIInjected = true
            console.log(`SP UI: SP interface injected`)
        }
    },

    updateSPPrice: function (sp_amount) {
        /*
            The SP price is calculated by 3% of the line item products in cart (excludes products that are tagged with not_physical_product).
            $60 is the highest you can charge the SP product because shopify doesn't allow to increase price.
        */
        const self = this
        const spPrice = Shopify.formatMoney(sp_amount * 0.03, window.theme.moneyFormat)
        const spPriceEl = document.querySelectorAll(`.sp-price`)
        spPriceEl.forEach((el) => {
            el.innerHTML = spPrice
        })
        console.log(`SP Action: SP Price updated to ${spPrice}`)
    },

    updateStatus: function (opt = false, user_action = false) {
        const self = this
        const spButtons = document.querySelectorAll(`.sp-button`)

        if (opt) {
            spButtons.forEach((el) => {
                el.classList.add(`active`)
                el.textContent = el.attributes['data-text-on'].value
            })
            localStorage.setItem('spOptIn', '1')
			if (user_action) {
				localStorage.setItem('spOptIn_user', 'opt_in')
				console.log(`SP Status: SP Opted In by User - ${localStorage.getItem('spOptIn_user')}`)
			}
            console.log(`SP Status: SP Opted In`)
        } else {
            spButtons.forEach((el) => {
                el.classList.remove(`active`)
                el.textContent = el.attributes['data-text-off'].value
            })
            localStorage.removeItem('spOptIn')
			if (user_action) {
				localStorage.setItem('spOptIn_user', 'opt_out')
				console.log(`SP Status: SP Opted Out by User - ${localStorage.getItem('spOptIn_user')}`)
			}
            console.log(`SP Status: SP Opted Out`)
        }
    },

	addSP: async function (variantId = null) {
		const self = this
		const url = window.Shopify.routes.root + 'cart/add.js' 
		const id = variantId ? variantId : ORW.SP.product.variantId

		if (!id) {
			console.log(`SP Action: SP product is not available to the current market`)
			return
		}

		const formData = {
			'id': `${id}`,
			'quantity': 1,
			'properties': {
				'shipping_protection': `true`
			}
		}

		const config = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData),
		};

		self.actionProxy.loading = true
		try {
            console.log(`SP Action: Adding SP ...`)
			const response = await fetch(url, config)
			self.SPChanged(response, `sp_added`)
		} catch (error) {
			console.log(`SP Action: Adding SP error`)
			console.log(error)
		}
		self.actionProxy.loading = false
	},

	removeSP: async function (variantId = null) {
		const self = this
		const url = window.Shopify.routes.root + 'cart/change.js'
		const id = variantId ? variantId : ORW.SP.product.variantId

		if (!id) {
			console.log(`SP Action: SP product is not available to the current market`)
			return
		}

		const formData = {
			'id': `${id}`,
			'quantity': 0
		};

		const config = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData),
		};

		self.actionProxy.loading = true
		try {
            console.log(`SP Action: Removing SP ...`)
			const response = await fetch(url, config)
			self.SPChanged(response, `sp_removed`)
		} catch (error) {
			console.log(`SP Action: Remove SP error`);
			console.log(error);
		}
		self.actionProxy.loading = false
	},

	updateSP: async function (updates = {}) {
		/*
			updates = {
				'variant_id_1': 'qty_1',
				'variant_id_2': 'qty_2',
				...
			}
		*/
		const self = this
		const url = window.Shopify.routes.root + 'cart/update.js'
		const config = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({updates}),
		};

		self.actionProxy.loading = true
		try {
            console.log(`SP Action: Updating SP ...`)
			const response = await fetch(url, config)
			self.SPChanged(response, `sp_updated`)
		} catch (error) {
			console.log(`SP Action: Reset/Update SP error`)
			console.log(error)
		}
		self.actionProxy.loading = false
	},

	SPChanged: function (data = {}, eventNameOverride = '') {
		const eventName = eventNameOverride ? eventNameOverride : `sp_changed`
		const event = new CustomEvent(eventName, { detail: data });
		window.dispatchEvent(event);
	},

	destroy: function() {
		const self = this
		self.undelegateEvents()
	}
});

// Define the module here 
const OneSP = {
	init: function (settings) {
		
		// If using Backbone View
		return new OneSPView({
			el: document.body,
		});
		
		// If not using Backbone View
		// return this;
	}
}

// Output the module
export default OneSP;

class CartWatcher {

	init() {
		this.emitCartChanges().then(() => {
			this.observeCartChanges();
		});
	}
  
	async fetchCart() {
		const response = await fetch('/cart.js');
		return response.json();
	}
  
	storeCart(cart) {
		localStorage.setItem('cart', JSON.stringify(cart));
	}
  
	storedCart() {
		return JSON.parse(localStorage.getItem('cart')) || { items: [] };
	}
  
   	findCartChanges(oldCart, newCart) {
		const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
		let result = {
			added: onlyInLeft(newCart.items, oldCart.items),
			removed: onlyInLeft(oldCart.items, newCart.items),
			currentCart: newCart.items,
		};

		oldCart.items.forEach(oi => {
			const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
			if (!ni) return;
			let quantity = ni.quantity - oi.quantity;
			let item = { ...ni };
			item.quantity = Math.abs(quantity);
			quantity > 0
				? result.added.push(item)
				: result.removed.push(item)
		});

		return result;
	}

	async stall(milliseconds) {
        return new Promise(resolve => {
            setTimeout(resolve, milliseconds);
        })
    }
  
	async emitCartChanges() {
		await this.stall(200)	// Wait a few before getting the cart as the request could be WIP.
		const newCart = await this.fetchCart();
		const oldCart = this.storedCart();
		const changes = this.findCartChanges(oldCart, newCart);

		const event = new CustomEvent("cart_changed", { detail: changes });
		window.dispatchEvent(event);

		this.storeCart(newCart);
	}
  
   	observeCartChanges() {
		const cartObserver = new PerformanceObserver((list) => {
			list.getEntries().forEach(async (entry) => {
				const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
				const isCartChangeRequest = /\/cart\//.test(entry.name);
				if (isValidRequestType && isCartChangeRequest) {
					await this.emitCartChanges();
				}
			});
		});
		cartObserver.observe({ entryTypes: ["resource"] });
	}
}